var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal", on: { click: _vm.clickModal } }, [
    _c(
      "div",
      {
        ref: "dialog",
        staticClass: "dialog chrome",
        style: _vm.styleObject,
        attrs: { id: _vm.dialogModel.cid },
        on: { click: _vm.stopDelegation },
      },
      [
        _c("div", { ref: "dialogHeader", staticClass: "header" }, [
          _c("div", { class: [{ closer: _vm.dialogModel.hasclose }] }, [
            _vm.dialogModel.hasclose
              ? _c(
                  "i",
                  {
                    staticClass: "material-icons",
                    on: { click: _vm.checkClose },
                  },
                  [_vm._v("\n\t\t\t\t\tclose\n\t\t\t\t")]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [
            _c("span", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("views.authDialog.welcomeUser", {
                    label: _vm.labelName,
                  })
                ),
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "dialogBody",
            staticClass: "body",
            style: Object.assign(
              {},
              { "max-height": _vm.maxBodyHeight + "px" },
              _vm.bodyStyle
            ),
          },
          [
            _vm.dialogModel.showSignup
              ? _c(
                  "SignupView",
                  _vm._g(
                    _vm._b({}, "SignupView", _vm.dialogModel.options, false),
                    Object.assign({}, _vm.componentListeners)
                  )
                )
              : _vm.dialogModel.showLogin
              ? _c(
                  "LoginView",
                  _vm._g(
                    _vm._b({}, "LoginView", _vm.dialogModel.options, false),
                    Object.assign({}, _vm.componentListeners)
                  )
                )
              : _c(
                  "LoginView",
                  _vm._g(
                    _vm._b({}, "LoginView", _vm.dialogModel.options, false),
                    Object.assign({}, _vm.componentListeners)
                  )
                ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }